import { render } from "./EditPhoto.vue?vue&type=template&id=c3478328&scoped=true"
import script from "./EditPhoto.vue?vue&type=script&lang=js"
export * from "./EditPhoto.vue?vue&type=script&lang=js"

import "./EditPhoto.vue?vue&type=style&index=0&id=c3478328&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3478328"]])

export default __exports__